import { Component, OnInit } from '@angular/core';

import { AuthService } from 'src/app/shared/auth.service';
import { MessageService } from 'src/app/shared/services';

@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent implements OnInit {

  oldPassword: string;
  newPassword: string;
  isChangingPassword: boolean;
  oldPasswordVisible: boolean = false;
  newPasswordVisible: boolean = false;

  constructor(
    private _authService: AuthService,
    private _messageService: MessageService) { }

  ngOnInit() {
    this.oldPassword = '';
    this.newPassword = '';
    this.isChangingPassword = false;
  }

  toggleOldPasswordVisability(): void {
    this.oldPasswordVisible = !this.oldPasswordVisible;
  }

  toggleNewPasswordVisability(): void {
    this.newPasswordVisible = !this.newPasswordVisible;
  }

  changePasswordSubmit(): void {
    this.isChangingPassword = true;

    this._authService.changeOldPassword(this.oldPassword, this.newPassword).subscribe(
      {
        next: () => {
          this._messageService.displayMessage({ body: 'global.success_change_password', type: 'success' });
          this._authService.logout();
        },
        error: () => this.isChangingPassword = false
      }
    );
  }

  validatePassword(criteria: string): boolean {
    let regex;
    switch (criteria) {
      case 'number':
        regex = RegExp(/\d/);
        return regex.test(this.newPassword);

      case 'special':
        regex = RegExp(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/);
        return regex.test(this.newPassword);

      case 'uppercase':
        regex = RegExp(/[A-Z]/);
        return regex.test(this.newPassword);

      case 'lowercase':
        regex = RegExp(/[a-z]/);
        return regex.test(this.newPassword);

      case 'length':
        return this.newPassword.length >= 8;
      
      case 'all':
        regex = RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/);
        return regex.test(this.newPassword);

      default:
        return false;
    }
  }

}
